import { v4 as uuidv4 } from 'uuid';

const requestIdByAction = new Map();
const inflightActionSet = new Set();

function normalizePart(value, fallback = '') {
    if (value === undefined || value === null) {
        return fallback;
    }
    const normalized = String(value).trim();
    return normalized || fallback;
}

export function createActionKey({
    scopeKey,
    imageId,
    featureCode,
    subFeatureCode,
    actionType
}) {
    const scopePart = normalizePart(scopeKey, '');
    return [
        scopePart || normalizePart(imageId, 'unknown-image'),
        normalizePart(featureCode, 'unknown-feature'),
        normalizePart(subFeatureCode, 'default'),
        normalizePart(actionType, 'unknown-action')
    ].join('::');
}

export function getOrCreateRequestId(actionKey) {
    if (!actionKey) {
        throw new Error('[requestIdRegistry] actionKey is required');
    }
    if (!requestIdByAction.has(actionKey)) {
        requestIdByAction.set(actionKey, uuidv4());
    }
    return requestIdByAction.get(actionKey);
}

export function getRequestId(actionKey) {
    return requestIdByAction.get(actionKey) || null;
}

export function markInflight(actionKey) {
    if (!actionKey) {
        throw new Error('[requestIdRegistry] actionKey is required');
    }
    if (inflightActionSet.has(actionKey)) {
        return false;
    }
    inflightActionSet.add(actionKey);
    return true;
}

export function clearInflight(actionKey) {
    if (!actionKey) {
        return;
    }
    inflightActionSet.delete(actionKey);
}

export function isInflight(actionKey) {
    return inflightActionSet.has(actionKey);
}

export function releaseAction(actionKey) {
    clearInflight(actionKey);
    requestIdByAction.delete(actionKey);
}

export function resetRequestIdRegistry() {
    inflightActionSet.clear();
    requestIdByAction.clear();
}
